import { CustomInput } from '@gs/gs-integration-component';

// CustomInput is the library's text box with an "add variable" popover. This app has no variable list to offer, so
// the popover never opens; the props that drive it are still required, and fixed here once.
const NO_VARIABLES = [];
const noop = () => {};

/**
 * @typedef {object} FreeTextInputProps
 * @property {string} label
 * @property {string} value
 * @property {(value: string) => void} onChange - the new text, not the event
 * @property {string} [helperText]
 * @property {string} [size] - the kit's TextField size, 'small' by default
 * @property {object} [style] - style of the wrapping div, where the library's markup has its own layout div
 * @property {string} ['data-testid'] - on the wrapping div: CustomInput takes none of its own
 */

/**
 * A free-text field in the library's CustomInput look, with no variable popover.
 * @param {FreeTextInputProps} props
 * @returns {JSX.Element}
 */
const FreeTextInput = ({
  label, value, onChange, helperText, size = 'small', style, 'data-testid': testId,
}) => (
  <div style={style} data-testid={testId}>
    <CustomInput
      label={label}
      value={value}
      helperText={helperText}
      size={size}
      variables={NO_VARIABLES}
      handleInputChange={onChange}
      handleDropdownChange={noop}
      showPopover={false}
      setShowPopover={noop}
    />
  </div>
);

export default FreeTextInput;
